<mat-card
  class="card-table has-progress-bar"
  [class.card-has-subtitle]="!onAppointmentPage"
  [style]="style"
>
  <mat-progress-bar mode="determinate"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span [class.text-warn]="invoice?.status === STATUS.VOID">
      <span *ngIf="invoice?.status === STATUS.DRAFT" class="text-warn">
        {{ 'common.draft' | translate }}
      </span>
      <ng-container *ngIf="invoice?.status === STATUS.VOID">
        {{ 'common.voided' | translate }}
      </ng-container>
      {{ 'common.invoice' | translate }}
      {{ invoice?.shortId | shortId }}
    </span>
    <div fxLayout="row" fxLayoutGap="1em">
      <mat-menu #invoiceSendMenu="matMenu">
        <button
          mat-menu-item
          [disabled]="isEmailSendDisabled()"
          (click)="openSendDialog('link', 'email')"
        >
          <mat-icon>send</mat-icon>
          {{ 'invoice-card.button-send-link' | translate }}
        </button>
        <button
          mat-menu-item
          [disabled]="isSmsSendDisabled()"
          (click)="openSendDialog('link', 'sms')"
        >
          <mat-icon>send</mat-icon>
          {{ 'invoice-card.button-send-sms' | translate }}
        </button>
        <ng-container
          *ngIf="!onAppointmentPage || invoice.status === STATUS.PAID"
        >
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            [disabled]="isReceiptSendDisabled()"
            (click)="openSendDialog('pdf')"
            [matTooltip]="'invoice-card.button-send-receipt-hint' | translate"
          >
            <mat-icon>send</mat-icon>
            <span>{{ 'invoice-card.button-send-receipt' | translate }}</span>
          </button>
        </ng-container>
      </mat-menu>
      <mat-menu #invoiceMenu="matMenu">
        <button
          mat-menu-item
          *ngIf="onAppointmentPage"
          [routerLink]="invoice.url"
        >
          <mat-icon>web</mat-icon>
          <span>View & Collect Payment</span>
        </button>
        <button
          mat-menu-item
          *ngIf="invoice?.status !== STATUS.VOID"
          (click)="download($event)"
        >
          <mat-icon>print</mat-icon>
          <span>{{ 'common.print' | translate }}</span>
        </button>
        <button
          mat-menu-item
          *ngIf="invoice?.status !== STATUS.VOID"
          [matMenuTriggerFor]="invoiceSendMenu"
        >
          <mat-icon>send</mat-icon>
          <span>{{ 'common.send' | translate }}</span>
        </button>
        <button
          mat-menu-item
          *ngIf="invoice?.status !== STATUS.VOID"
          [disabled]="invoice.status === STATUS.PAID"
          (click)="void()"
          color="warn"
        >
          <mat-icon>delete</mat-icon>
          <span>{{ 'common.void' | translate }}</span>
        </button>
      </mat-menu>
      <button
        mat-stroked-button
        fxHide.lt-md
        *ngIf="invoice?.status !== STATUS.VOID"
        (click)="download($event)"
      >
        <mat-icon>print</mat-icon>
        <span>{{ 'common.print' | translate }}</span>
      </button>
      <button
        mat-stroked-button
        fxHide.lt-md
        *ngIf="invoice?.status !== STATUS.VOID"
        [matMenuTriggerFor]="invoiceSendMenu"
      >
        <mat-icon>send</mat-icon>
        <span>{{ 'common.send' | translate }}</span>
      </button>
      <button
        mat-stroked-button
        fxHide.lt-md
        *ngIf="invoice?.status !== STATUS.VOID"
        [disabled]="invoice.status === STATUS.PAID"
        (click)="void()"
        color="warn"
      >
        <mat-icon>delete</mat-icon>
        <span>{{ 'common.void' | translate }}</span>
      </button>
      <ng-container *ngIf="onAppointmentPage">
        <button
          *ngIf="
            invoice.status === STATUS.VOID || invoice.status === STATUS.PAID;
            else accentedButton
          "
          fxHide.xs
          mat-stroked-button
          [routerLink]="invoice.url"
        >
          <mat-icon>web</mat-icon>
          <span>{{ 'invoice-card.view-collect-payment' | translate }}</span>
        </button>
        <ng-template #accentedButton>
          <button
            mat-flat-button
            color="accent"
            fxHide.xs
            [routerLink]="invoice.url"
          >
            <mat-icon>web</mat-icon>
            <span>{{ 'invoice-card.view-collect-payment' | translate }}</span>
          </button>
        </ng-template>
      </ng-container>

      <button
        mat-icon-button
        fxHide
        fxShow.lt-md
        [matMenuTriggerFor]="invoiceMenu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </mat-card-title>

  <mmx-invoice-subtitle *ngIf="!onAppointmentPage" [invoice]="invoice"></mmx-invoice-subtitle>

  <mat-card-content class="px-2">
    <table class="mat-table mat-table--wide">
      <thead>
        <tr>
          <th class="text-left">{{ 'invoice-card.procedure-or-service' | translate }}</th>
          <th class="text-right">{{ 'invoice-card.units' | translate }}</th>
          <th class="text-right">{{ 'common.total' | translate }}</th>
        </tr>
      </thead>
      <tr *ngFor="let item of invoice.lineItems">
        <td>{{ item.description }}</td>
        <td class="text-right">{{ item.quantity ?? 1 }}</td>
        <td class="text-right">
          <ng-container *ngIf="item.expectedAmount; else noExpectedAmount">
            {{ item.expectedAmount | currency: defaultCurrency }}
          </ng-container>
          <ng-template #noExpectedAmount>
            {{ item.amount | currency: defaultCurrency }}
          </ng-template>
        </td>
      </tr>
      <tr class="last-answers" *ngIf="!invoice.estimate">
        <td class="pt-1" colspan="2">
          <strong>{{ 'common.total' | translate }}</strong>
        </td>
        <td class="pt-1 text-right">
          <strong>{{ invoice?.total | currency: defaultCurrency }}</strong>
        </td>
      </tr>

      <!-- <ng-container *ngIf="invoice.estimate">
        <tr *ngIf="invoice.estimate.insuranceResponsibility != null" class="last-answers">
          <td class="pt-1" colspan="2">
            Primary Insurance Responsibility
          </td>
          <td class="pt-1 text-right">
            {{ -invoice.estimate.insuranceResponsibility | currency:invoice?.currency:defaultCurrency }}
          </td>
        </tr>
        <tr *ngIf="invoice.estimate.secondaryInsuranceResponsibility != null" class="last-answers">
          <td class="pt-1" colspan="2">
            Secondary Insurance Responsibility
          </td>
          <td class="pt-1 text-right">
            {{ -invoice.estimate.secondaryInsuranceResponsibility | currency:invoice?.currency:defaultCurrency }}
          </td>
        </tr>
      </ng-container> -->
    </table>
    <section
      *ngIf="invoice.estimate && invoice.estimate.insuranceType === 'medical'"
    >
      <div class="mt-6">
        <strong>
          {{ 'invoice-card.primary-insurance-benefits' | translate }}
        </strong>
      </div>
      <hr />
      <ul class="leaders">
        <li
          *ngIf="
            invoice.estimate.deductible || invoice.estimate.deductibleApplied
          "
        >
          <span
            >{{ 'invoice-card.remaining-deductible' | translate }}:
            {{ invoice.estimate.deductible | currency: defaultCurrency }}</span
          >
          <span>{{
            invoice.estimate.deductibleApplied | currency: defaultCurrency
          }}</span>
        </li>
        <li
          *ngIf="
            invoice.estimate.copayment || invoice.estimate.copaymentApplied
          "
        >
          <span
            >{{ 'invoice-card.co-payment' | translate }}:
            {{ invoice.estimate.copayment | currency: defaultCurrency }}</span
          >
          <span>{{
            invoice.estimate.copaymentApplied | currency: defaultCurrency
          }}</span>
        </li>
        <li
          *ngIf="
            invoice.estimate.coinsurance || invoice.estimate.coinsuranceApplied
          "
        >
          <span
            >{{ 'invoice-card.co-insurance' | translate }}:
            {{ invoice.estimate.coinsurance * 100 }}%</span
          >
          <span>{{
            invoice.estimate.coinsuranceApplied | currency: defaultCurrency
          }}</span>
        </li>
        <li
          *ngIf="
            invoice.estimate.outOfPocketMax ||
            invoice.estimate.outOfPocketMaxApplied
          "
        >
          <span
            >{{ 'invoice-card.remaining-oop-max' | translate }}:
            {{
              invoice.estimate.outOfPocketMax | currency: defaultCurrency
            }}</span
          >
          <span>{{
            invoice.estimate.outOfPocketMaxApplied | currency: defaultCurrency
          }}</span>
        </li>
        <ng-container *ngIf="invoice.exclusiveTaxes.length > 0">
          <li *ngFor="let exclusiveTax of invoice.exclusiveTaxes">
            <span
              >{{ exclusiveTax.description }}
              {{ exclusiveTax.percentage }}%:</span
            >
            <span>{{ exclusiveTax.amount | currency: defaultCurrency }}</span>
          </li>
        </ng-container>
        <ng-container *ngIf="invoice.inclusiveTaxes.length > 0">
          <li *ngFor="let inclusiveTax of invoice.inclusiveTaxes">
            <span
              >{{ inclusiveTax.description }} {{ inclusiveTax.percentage }}%
              (included):</span
            >
            <span>{{ inclusiveTax.amount | currency: defaultCurrency }}</span>
          </li>
        </ng-container>
        <li *ngIf="invoice.plan && invoice.plan.fee">
          <span>{{ 'invoice-card.fees-payment-plan' | translate }}:</span>
          <span>{{ invoice.plan.fee | currency: defaultCurrency }}</span>
        </li>
        <li *ngIf="invoice.taxAmount && invoice.plan && invoice.plan.months">
          <span
            >{{ 'invoice-card.fee-amount' | translate }}:
            {{ invoice.taxAmount | currency: defaultCurrency }},
            {{ invoice.plan.months }} months</span
          >
          <span>{{
            invoice.taxAmount * invoice.plan.months | currency: defaultCurrency
          }}</span>
        </li>
        <li
          *ngIf="
              (invoice.feePaid && !invoice.paymentOption) ||
              invoice.plan?.fee < invoice.feeDue
            "
        >
            <span
            >{{ 'invoice-card.fees-collected-cancelled' | translate }}:</span
            >
          <span>{{
              invoice.feeDue - invoice.plan?.fee | currency: defaultCurrency
            }}</span>
        </li>
        @if(invoice.estimate?.discountApplied && !invoice.plan) {
          <li>
            @if (invoice.estimate?.discountPercentage > 0) {
              <span>{{ 'estimate.discount' | translate }} ({{ invoice.estimate.discountPercentage }}%):</span>
            } @else {
              <span>{{ 'estimate.discount' | translate }}:</span>
            }
            <span>{{ -invoice.estimate.discountApplied | currency: defaultCurrency }}</span>
          </li>
        }
        <li *ngIf="invoice.estimate?.cptDiscountApplied && !invoice.plan">
          <span>{{ 'estimate.cpt-discount' | translate }}:</span>
          <span>{{ -invoice.estimate.cptDiscountApplied | currency: defaultCurrency }}</span>
        </li>
        <li *ngIf="invoice.discount && !invoice.plan">
            <span
            >{{ 'invoice-card.discount-bill' | translate }}:
              {{ invoice.discount.percent }}%</span
            >
          <span>{{
              -invoice.discount.amount | currency: defaultCurrency
            }}</span>
        </li>
      </ul>
    </section>
    <sat-popover #taxInfo hasBackdrop verticalAlign="below">
      <mat-card>
        <mat-card-content>
          <ul>
            <li *ngFor="let taxAmount of invoice.taxAmounts">
              <strong>{{ taxAmount.description }}.</strong>
              {{ taxAmount.percentage }}%
              <span *ngIf="taxAmount.inclusive"
                >({{ 'invoice-card.inclusive' | translate }})</span
              >.
              {{
                'invoice-card.tax-details'
                  | translate
                    : { value: taxAmount.amount | currency: defaultCurrency }
              }}
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
    </sat-popover>
  </mat-card-content>

  <mat-card-footer *ngIf="invoice.estimate" fxLayout>
    <ng-container *ngIf="invoice.estimate.insuranceType === 'medical'">
      <div class="pays" fxFlex fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <span>
            {{ 'invoice-card.primary-insurance-pays' | translate }}
          </span>
          <strong class="cost">
            {{ invoice.estimate.insuranceResponsibility | currency: defaultCurrency }}
          </strong>
        </div>
        <div
          *ngIf="invoice.estimate.secondaryInsuranceResponsibility != null"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <span>
            {{ 'invoice-card.secondary-insurance-pays' | translate }}
          </span>
          <strong class="cost">
            {{ invoice.estimate.secondaryInsuranceResponsibility | currency: defaultCurrency }}
          </strong>
        </div>
      </div>
    </ng-container>
    <div
      class="pays"
      fxFlex
      fxLayout
      fxLayoutAlign="space-between"
      *ngIf="invoice.estimate.insuranceType === 'selfpay'"
    >
      <span>{{ 'invoice-card.insurance-pays' | translate }}</span>
      <p class="cost">{{ 'invoice-card.self-pay' | translate }}</p>
    </div>
    <div
      class="pays"
      fxFlex
      fxLayout
      fxLayoutAlign="space-between"
      *ngIf="
        invoice.estimate.insuranceType === 'lien' ||
        invoice.estimate.insuranceType === 'wc' ||
        invoice.estimate.insuranceType === 'inmate'
      "
    >
      <div fxLayout="column">
        <span>{{ 'invoice-card.primary-payer-pays' | translate }}</span>
        <span
          *ngIf="invoice.estimate.insuranceType === 'lien'"
          class="text-sm"
          >{{ 'invoice-card.lien' | translate }}</span
        >
        <span *ngIf="invoice.estimate.insuranceType === 'wc'" class="text-sm">{{
          'invoice-card.workers' | translate
        }}</span>
        <span *ngIf="invoice.estimate.insuranceType === 'inmate'" class="text-sm">{{
          'invoice-card.inmate' | translate
        }}</span>
      </div>
      <p class="cost">
        <strong>{{
          invoice.estimate.insuranceResponsibility | currency: defaultCurrency
        }}</strong>
      </p>
    </div>
    <div class="pays" fxFlex fxLayout fxLayoutAlign="space-between">
      <div>
        <p>{{ 'invoice-card.patient-pays' | translate }}</p>
        <p>{{ 'invoice-card.amount-due' | translate }}</p>
        <p>{{ 'invoice-card.amount-paid' | translate }}</p>
        <p>{{ 'invoice-card.amount-remaining' | translate }}</p>
        <p *ngIf="invoice.amountRemaining < 0">
          {{ 'invoice-card.refund-due' | translate }}
        </p>
        <p
          *ngIf="pendingAmount > 0"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="0.25em"
        >
          <span
            >{{ 'invoice-card.pending' | translate }}:
            {{ pendingAmount | currency: defaultCurrency }}</span
          >
          <mat-icon
            class="ql-size-small"
            color="warn"
            [matTooltip]="'invoice-card.pending-hint' | translate"
            >help</mat-icon
          >
        </p>
      </div>
      <div>
        <p class="cost">
          <strong>{{ invoice.total | currency: defaultCurrency }}</strong>
        </p>
        <p>
          <strong>{{ invoice.amountDue | currency: defaultCurrency }}</strong>
        </p>
        <p>
          <strong>{{ invoice.amountPaid | currency: defaultCurrency }}</strong>
        </p>
        <ng-container
          *ngIf="invoice.amountRemaining >= 0; else negativeAmountRemaining"
        >
          <p>
            <strong>{{
              invoice.amountRemaining | currency: defaultCurrency
            }}</strong>
          </p>
        </ng-container>
        <ng-template #negativeAmountRemaining>
          <p>
            <strong>{{ 0 | currency: defaultCurrency }}</strong>
          </p>
          <p>
            <strong>{{
              invoice.amountRemaining * -1 | currency: defaultCurrency
            }}</strong>
          </p>
        </ng-template>
      </div>
    </div>
  </mat-card-footer>
</mat-card>
